import { FieldView } from "./view-field";
import type { FieldProps } from "./types-field";

export function Field(props: FieldProps) {
  return <FieldView {...props} />;
}

export type * from "./types-field";
